





































































































































































































import { MasterlinkMenuServiceProxy,AppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import Vue from 'vue'
import { putFilePOST } from '@/api/api'
import moment from 'moment'
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
}
const Service = new AppServiceProxy()
const menuservice = new MasterlinkMenuServiceProxy()
export default Vue.extend ({
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    clientList:{ // 客户端列表
      type: Array,
      default: () => ([])
    },
    audienceList:{ // 受众列表
      type: Array,
      default: () => ([])
    },
    statusList:{ // 状态列表
      type: Array,
      default: () => ([])
    },
    salestatusList:{ // 上架状态
      type: Array,
      default: () => ([])
    },
    menuList:{ // 关联菜单
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      rolesList:[],
      value: undefined,
      imageUrl: '',
      loading: false,
      height: '763px',
      audience: [],
    }
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(file: any) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      putFilePOST(formData).then((res: any) => {
        if (res) {
          this.imageUrl = res.data.data.link
          // this.saveAvatar() // 保存新头像
          // this.$message.success(res.data.msg)
          this.loading = false
        }
      }, () => {
        this.loading = false
      })
    },
    beforeUpload(file: any) {
      const isPng = file.type === 'image/png';
      const isLt30k = file.size / 1024 < 30;
      if (!isPng) {
        this.$message.error('你只能上传png图片!');
        return false
      }
      if (!isLt30k) {
        this.$message.error('图片不能超过30KB!');
        return false
      }
    },
    onClose() {
      this.form.resetFields()
      this.imageUrl = ''
      this.$emit('close',false)
    },
    save(){
      this.form.validateFields((err: any,values: any) => {
        if (!err) {
          if(values.audience){
            values.audience = this.addVlaue(values.audience)
          }
          if(values.bizMenuId){
            values.bizMenuId = values.bizMenuId.join(',')
          }
          const params = {
            audience: values.audience,
            avatar :this.imageUrl,
            ...values
          }
          Service.insertApp(params).then(() =>{
            this.$message.success('新建成功')
            this.form.resetFields()
            this.imageUrl = ''
            this.$emit('close',true)
          })
        }
      })
    },
    addVlaue(item: any){
      let audie = 0
      item.forEach((element: any) => {
        audie = Number(element) + audie
      });
      return audie
    }
  }
})
